import { render, staticRenderFns } from "./ResourcePopoverPreview.vue?vue&type=template&id=3a60dc81&scoped=true"
import script from "./ResourcePopoverPreview.vue?vue&type=script&lang=js"
export * from "./ResourcePopoverPreview.vue?vue&type=script&lang=js"
import style0 from "./ResourcePopoverPreview.vue?vue&type=style&index=0&id=3a60dc81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60dc81",
  null
  
)

export default component.exports